'use strict';
const moment = require('moment');
import { keyBy } from 'lodash';
import { ToastService } from '../../../components/toasts/Toasts';
import { goToDynamicURL } from '../../../modules/emails/util';
import { STATES } from '../../../common/data/uiData';
import emailAlertsFiltersStore from '../../../modules/emails/EmailAlertsFiltersStore';
import {
    userManagementAllowed,
    emailAlertsAdminAllowed
} from '../../../modules/app/site/featureAccessControl';
import SessionStore from '../../../services/session/SessionStore';

angular.module('clientDashboardApp').controller("ManageEmailAlertsCtrl", function($scope, $state, emailAlertService, stateService, confirmService, $uibModal, userService, userManagerService, configService, reactContainer) {
  
  const { accounts, loading } = reactContainer.getContainer();
  
  $scope.loading = loading;

  $scope.STATES = STATES;
  $scope.currentPage = $state.current.name
  configService.getEmailConfig().then(resp => {
    $scope.emailConfig = resp.data;
  })

  let user = SessionStore.user;

  const accountMap = {[user.accountId]: true}
  accounts.forEach(a => accountMap[a.id] = true)
  $scope.isAdmin = emailAlertsAdminAllowed();
  $scope.hasUserManagement = userManagementAllowed();
  stateService.setState($scope.STATES.loading)

  const pageSize = 15;
  $scope.myCurrentPage = 1;
  $scope.initialLoad = true;

  $scope.filters = {
    'all': { value: {} },
    'createdByMe': { value: {createdBy: user.userId} },
    'addressedToMe': { value: {recipient: user.userId} }
  };

  $scope.filterModel = $scope.filters[emailAlertsFiltersStore.state.userFilterModelValue];

  $scope.isInternetExplorer = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident") > -1
  $scope.isFirefox = window.navigator.userAgent.indexOf("Firefox") > -1

  const notAdminAndNotMyAlert = (alert) => !($scope.isAdmin && accountMap[alert.accountId]) && (user.userId !== alert.createdBy)

  $scope.actions = [
    {
      name: () => ('Edit'),
      classes: () => ('fas fa-edit'),
      onClick: (alertData) => {
        let alert = alertData.alert;
        goToDynamicURL(`/#/emailAlerts/manage/${alert._id}/edit`);
      },
      hideIf: notAdminAndNotMyAlert
    },
    {
      name: () => ('Copy'),
      classes: () => ('fas fa-layer-group'),
      onClick: (alertData) => {
        goToDynamicURL(`/#/emailAlerts/manage/${alertData.alert._id}/copy`);
        // emailAlertService.getAlert(alertData.alert._id).then(alert => {
        //   let alertCopy = angular.copy({...alert, name:`Copy of ${alert.name}`, createdBy:user.userId})
        //   console.log("🚀 ~ file: manage.js ~ line 67 ~ emailAlertService.getAlert ~ alertCopy", alertCopy)
        //   let idOfCopied = alertCopy._id
        //   delete alertCopy._id
          
        // })
      },
      hideIf: notAdminAndNotMyAlert
    },
    {
      name: () => ('Send Test'),
      classes: () => ('fas fa-paper-plane'),
      onClick: (alertData) => {
        $scope.sendTest(alertData)
      },
      hideIf: notAdminAndNotMyAlert
    },
    {
      name:(alertData) => ( alertData.subscribed ? 'Unsubscribe' : 'Subscribe' ),
      classes: (alertData) => ( alertData.subscribed ? 'fas fa-bell-slash' : 'fas fa-bell' ),
      onClick: (alertData) => {
        $scope.updateSubscription(alertData)
      },
      hideIf: (alert) => !alert.enabled
    },
    {
      name: () => ('Delete'),
      classes: () => ('fas fa-trash-alt'),
      onClick: (alertData) => {
        let alert = alertData.alert
        confirmService.confirm("Confirm Deletion", "This alert will be permanently removed, and no further messages will be sent", confirmService.DELETE).then(shouldDelete => {
          if (!shouldDelete) return;
          stateService.setState($scope.STATES.updating)
          emailAlertService.deleteAlert(alert._id).then( () => {
            updateResults($scope.myCurrentPage,pageSize)
          })
        })
      },
      hideIf: notAdminAndNotMyAlert
    }
  ]

  $scope.sendTest = function(alertData) {
    let alert = alertData.alert
    $uibModal.open({
      template: require("./confirmTestEmail.html"),
      controller: function ($scope) {
        $scope.test = {
          startDate: moment().subtract(1, 'days').toDate(),
          datepickerOptions: {
            maxDate: moment().subtract(1, 'days').toDate(),
            showWeeks: false
          },
          isSending: false
        }

        $scope.sendTest = function () {
          if ($scope.testEmailForm.$valid) {
            $scope.test.isSending = true;
            emailAlertService.sendTest(alert._id, $scope.test.emailAddress, $scope.test.startDate.getTime()).then(resp => {
              ToastService.success("Success", "Test email has been sent")
              $scope.$close();
            }, errorResp => {
              if (errorResp.status === 503) {
                ToastService.warning("Unable to Send", "No data found to send - try an earlier date or different alert settings");
              } else {
                ToastService.error("Unable to Send", "Failed to send email; please try again in a few minutes, or contact support");
              }
            }).finally(() => { $scope.test.isSending = false})
          }
        }
      }
    })
  }

  $scope.pageChanged = (newPage) => {
    if(newPage !== $scope.myCurrentPage){
      updateResults(newPage, pageSize)
    }
  }

  $scope.toggleEnabled = (alert) => {
    alert.enabled = !alert.enabled
    emailAlertService.saveAlert(alert).then((resp) => {

      // Replace item at index using native splice
      let index = _.findIndex($scope.emailAlerts.results, item => (item.alert._id === alert._id));
      $scope.emailAlerts.results.splice(index, 1, resp.data);
    },() => {
      //TODO: add better error handling
    })
  }

  $scope.updateSubscription = (alertData) => {
    // TODO toast service
    alertData.subscribed = !alertData.subscribed
    if (alertData.subscribed) {
      emailAlertService.subscribe(alertData.alert._id).then(success => {
        ToastService.success("Success", "Subscribed to notification")
      })
    } else {
      emailAlertService.unsubscribe(alertData.alert._id).then(success => {
        ToastService.success("Success", "Unsubscribed from notification")
      })
    }
  }

  const updateResults = (page, pageSize) => {
    $scope.initialLoad ? stateService.setState($scope.STATES.loading) : stateService.setState($scope.STATES.updating)
    emailAlertService.getAlerts(
      (page - 1) * pageSize,
      pageSize,
      $scope.filterModel.value,
      emailAlertsFiltersStore.state.subjectQuery === "" ? undefined : emailAlertsFiltersStore.state.subjectQuery
    ).then(resp => {
      $scope.emailAlerts = {
        results: resp.alerts,
        total: resp.total
      }
      let userIds = resp.alerts.filter(item => (item.alert.createdBy)).map(item => (item.alert.createdBy))
      if($scope.hasUserManagement){
        userManagerService.listUsers(null, "", 0, 10000, true, userIds).then(resp => {
          const data = !!resp.length ? resp[0].data.users : [];
          $scope.usersKeyedById = keyBy(data, "id");
        })
      }
      $scope.total = resp.total
      stateService.setState($scope.STATES.success)
      $scope.initialLoad = false;
      $scope.myCurrentPage = page;
    });
  }

  

  updateResults($scope.myCurrentPage, pageSize);
});
